__webpack_require__.p = "/modules/custom/nescafe_videoquiz/dist/";